import { useQuery, useQueryClient } from 'react-query'

import { ChamadoTecnicoService } from '../services/chamado-tecnico.service'
import { ChamadoService } from '../services/chamado.service'

export const useGetCallDetails = (callId?: string | number) => {
  const queryClient = useQueryClient()

  const query = useQuery(
    ['useGetCallDetails', { callId: Number(callId) }],
    async () => {
      if (callId) {
        const call = await ChamadoService.findById({
          callId: Number(callId),
        })
        const callTech = await ChamadoTecnicoService.findById({
          callId: Number(callId),
        })

        return {
          call,
          callTech: callTech.CallTechUserReport,
        }
      }
    },
  )

  function invalidateCallDetails() {
    queryClient.invalidateQueries(['useGetCallDetails', { callId }])
  }

  return { query, invalidateCallDetails }
}
